var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.57777 0 12.4573C0 18.7026 4.432 23.86 10.206 24.761V15.7585H7.237V12.4843H10.206V10.3053C10.206 6.6979 11.899 5.11478 14.787 5.11478C16.17 5.11478 16.902 5.2217 17.248 5.26945V8.12737H15.278C14.052 8.12737 13.624 9.3347 13.624 10.6946V12.4843H17.217L16.73 15.7585H13.624V24.787C19.481 23.9627 24 18.7639 24 12.4573C24 5.57777 18.627 0 12 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBook);
export default __webpack_public_path__ + "static/media/FaceBook.d1ec9e607f4f460aa3d3ed884dbf9c95.svg";
export { ForwardRef as ReactComponent };